export default "__VITE_ASSET__80d8c586__"